module.exports = "http://cdn.realive.com.ua/src/views/player/documets/fib/images/fib_logo.png";